import type { FunctionComponent } from "react";
import type { RecordJobData } from "@smartsuite/automation-engine-api";
import { ActivityDetailsTriggerGroup } from "../ActivityDetailsTriggerGroup/ActivityDetailsTriggerGroup";
import { ActivityDetailsItem } from "../ActivityDetailsItem/ActivityDetailsItem";
import {
  filterEntireFieldsFromRecordJobData,
  findOutputValueAndLabel,
  getOutputValue,
  getRecordListOutputs,
} from "../../utils";
import { LinkToRecord } from "../DeleteRecordsGroup/LinkToRecord";
import { addEmptyValueIfNeeded } from "../../../ActivityGrid/ActivityGrid.helpers";

export const GeneralDeleteGroupWrapper: FunctionComponent<{
  index: number;
  onDetailsClickWithFetch?: (recordJodId: string) => Promise<void>;
  onDetailsClick?: () => void;
  recordJodId?: string;
  recordJob?: RecordJobData;
}> = ({
  index,
  recordJob,
  onDetailsClickWithFetch,
  recordJodId,
  onDetailsClick,
}) => {
  const outputs =
    recordJob?.outputData !== undefined
      ? getRecordListOutputs(recordJob.outputData)
      : [];

  // do not show entire fields
  const withoutEnterFields = filterEntireFieldsFromRecordJobData(outputs);

  const filteredOutputs = withoutEnterFields.filter((output) =>
    ["title"].includes(output.outputId),
  );

  const mergedRecord = findOutputValueAndLabel("record_id", outputs);
  const solutionId = findOutputValueAndLabel("solution_id", outputs);
  const applicationId = findOutputValueAndLabel("application_id", outputs);

  return (
    <ActivityDetailsTriggerGroup
      title={`Deleted Record ${index + 1}`}
      onClick={() => {
        if (onDetailsClick !== undefined) {
          onDetailsClick();
        }
        if (
          onDetailsClickWithFetch !== undefined &&
          recordJodId !== undefined
        ) {
          void onDetailsClickWithFetch(recordJodId);
        }
      }}
    >
      <ActivityDetailsItem label={"Deleted Record Id"}>
        <LinkToRecord
          recordId={mergedRecord}
          solutionId={solutionId}
          applicationId={applicationId}
        />
      </ActivityDetailsItem>
      {filteredOutputs
        .filter((output) => output.outputId !== "record_id")
        .map((output) => {
          return (
            <ActivityDetailsItem
              key={output.outputId}
              label={output.outputLabel}
            >
              {addEmptyValueIfNeeded(getOutputValue(output.value))}
            </ActivityDetailsItem>
          );
        })}
    </ActivityDetailsTriggerGroup>
  );
};
